import { UserProfile } from '../model/user-profile.model';
import * as userActions from '../actions/user-profile.actions';

/**
 * User profile reducer handles user profile actions.
 */
export function userProfile(state: UserProfile, action: userActions.Actions): UserProfile {
    switch (action.type) {
        case userActions.LOAD_SUCCESS: {
            return {...action.payload};
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/userProfile.reducer.ts